var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};



// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $(".tabs");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.tabs [data-toggle]', function(e){
        e.preventDefault();
        
        var $tabID = $(this).data("toggle");

        $(this).parents('.tabs').find("[data-toggle], .tabs__content").removeClass("active");
        
        $(this).parents('.tabs').find(".tabs__nav [data-toggle='"+$tabID+"']").addClass("active");
        $(this).parents('.tabs').find("#"+$tabID).addClass("active");
    })
};



// Accordion
//-----------------------------------------------------------------
mp.accordion = function() {
    var $element = $(".accordion");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.accordion [data-toggle]', function(e){
        e.preventDefault();
        
        $(this).parents('.accordion__item').toggleClass("active").find('[data-content]').slideToggle();
    })
};



// Typed
//-----------------------------------------------------------------
mp.typedText = function() {
    var $element = $(".typed");

    if (!$element.length) {
        return;
    }

    var typed = new Typed(".typed",{
        stringsElement: '#typed-strings',
        typeSpeed: 80,
        backSpeed: 40,
        startDelay: 200,
        backDelay: 2000,
        loop: true,
        contentType: 'html'
    });
};



// Masonry Grid
//-----------------------------------------------------------------
mp.masonryGrid = function() {
    var $element = $(".masonry");

    if (!$element.length) {
        return;
    }

    $masonryGrid = $element.masonry({
        itemSelector: '.masonry-item'
    });

    $masonryGrid.imagesLoaded().progress( function() {
      $masonryGrid.masonry('layout');
    });
};



// Parallax
//-----------------------------------------------------------------
mp.parallax = function() {
    var $element = $(".parallax");

    if (!$element.length) {
        return;
    }

    var $images = document.querySelectorAll('.parallax');

    new simpleParallax($images, {
        scale: 1.3,
    });
};



$(document).ready(function (){
    mp.fancyBox();
    mp.tabs();
    mp.typedText();
    mp.accordion();
    mp.masonryGrid();
    mp.parallax();
    //mp.backgroundHolder();
});